import React, { useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";

import { DocusealForm } from "@docuseal/react";
import { API_SERVICE_BACKEND, selfURL } from "src/config";
import { useParams } from "react-router-dom";
import { useTheme } from "@mui/material";

const handleChange = async (data) => {
  // //console.log(key, value)
  if (data.status == "completed") {
    const res = await axios.patch(`${API_SERVICE_BACKEND}/patchUser`, {
      email: data.email,
      payload: {
        signature: {
          status: data.status,
          signatureId: data.submission_id,
          signatureUrl: data.submission_url,
        },
      },
    });

    if (res.data.status) {
      //   window.location.href = `${selfURL}/dashboard/account`;
    } else {
      toast.error(
        "Something went wrong with signature, please try again later"
      );
    }
  } else {
    toast.error("Something went wrong with signature, please try again later");
  }
};

const SignaturePage = () => {
  //   return <DocusealForm src="https://docuseal.co/d/YcmMPUwczxmDP5" />;
  const theme = useTheme();
  let { email } = useParams();
  //console.log("email: ", email);
  const getDomainFromLocation = () => {
    const domain = window.location.host;
    return domain;
  };
  const domain2 = localStorage.getItem('domain');
  //console.log("domain2: ", domain2);
  //console.log("domain2: ", getDomainFromLocation());
  //console.log("domain2: ", localStorage.getItem('domain'));
  const customCss = `
    .template-title {color: ${theme.palette.text.primary};}
    .submitted-form-company-logo h1{color: ${theme.palette.text.primary}}
    .submitted-form-title{color: ${theme.palette.text.primary}}
    .submitted-form-resubmit-button{border: 1px solid ${theme.palette.text.primary}}
  `
  return (
    <div className="app">
      <DocusealForm
        src="https://docuseal.co/d/YcmMPUwczxmDP5"
        completedButton={{
          title: "Click me to finish",
          url: `http://${getDomainFromLocation()}/auth-main/pricingPage`,
        }}
        email={email}
        onComplete={(data) => handleChange(data)}
        customCss={customCss}
      />
    </div>
  );
};

export default SignaturePage;
